import { render, staticRenderFns } from "./GuppyChatMessageFooter.vue?vue&type=template&id=632cab14&"
import script from "./GuppyChatMessageFooter.vue?vue&type=script&lang=js&"
export * from "./GuppyChatMessageFooter.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatMessageFooter.vue?vue&type=style&index=0&id=632cab14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports